import React from 'react';
import { classNames } from '../../utils/classNames';
import Title from '../title/Title';
import NewTitle from '../title/newTitle';

import './TitleBlock.css'

export function TitleBlock(props: {
    titleId?: string,
    title?: string | JSX.Element,
    titleClassName?: string
    children?: JSX.Element | JSX.Element[] | string
    className?: string
    onWheel?: (event: React.WheelEvent<HTMLDivElement>) => void
    titleValues?: any
    styleBlock?: React.CSSProperties
}) {
    return (
        <div className={classNames("title-block", props.titleClassName)} >
            {/* <NewTitle titleId={props.titleId} titleValues={props.titleValues} title={props.title} /> */}
            <div className={classNames("title-block-container", props.className)} onWheel={props.onWheel} style={props.styleBlock}>{props.children}</div>
        </div>
    )
}